import { useQuery } from '@tanstack/react-query';

import { listTeamLeagueLocations } from '@/infrastructure/network/data/module/list-team-league-locations';

export const useTeamLeagueLocationsQuery = (teamLeagueUuid: string) => {
	return useQuery({
		queryKey: ['SYSTEM_LOCATIONS', teamLeagueUuid],
		queryFn: () => listTeamLeagueLocations({ moduleUuid: teamLeagueUuid }),
		enabled: !!teamLeagueUuid
	});
};
